import { createFileRoute } from "@tanstack/react-router";
import { LiveDirectWatchEndTemplate } from "~/features/live/LiveDirectWatchEndTemplate";

// 配信終了などのエラーモーダルを _authenticated レイアウトで出すため、こちらは認証配下に置く
export const Route = createFileRoute("/_authenticated/watch-end/")({
  component: LiveDirectWatchEndTemplate,
});
